export default "__VITE_ASSET__TTBp$Oml__"